module.exports = __webpack_public_path__ + "797970e73874d294835f19c6d270fbed.pdf";